<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,802.5l-3.47-2l1-1.73l2.46,1.42l2.46-1.42l1,1.73L0.5,802.5z M-4.69,799.5l-3.47-2v-4h2v2.85l2.46,1.43L-4.69,799.5z
	 M5.69,799.5l-1-1.73l2.46-1.43v-2.85h2v4L5.69,799.5z M-8.16,791.5v-4l3.47-2l1,1.73l-2.46,1.42v2.85H-8.16z M7.16,791.5v-2.85
	l-2.46-1.42l1-1.73l3.47,2v4H7.16z M-1.96,786.23l-1-1.73l3.47-2l3.46,2l-1,1.73l-2.46-1.42L-1.96,786.23z M0.5,796.5l3.46-2v-4
	l-3.46-2l-3.47,2v4L0.5,796.5z"/>
</svg>

</template>